import { IconButton, Tooltip } from '@mui/material';
import { useEffect, useState } from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

type Props = {
	value: string;
	ariaLabel: string;
};

const CopyIconButton = ({ value, ariaLabel }: Props) => {
	const [copied, setCopied] = useState(false);

	useEffect(() => {
		if (!copied) {
			return;
		}
		const timeout = setTimeout(() => setCopied(false), 1500);
		return () => clearTimeout(timeout);
	}, [copied]);

	const handleCopy = () => {
		if (!value) {
			return;
		}
		if (navigator?.clipboard?.writeText) {
			navigator.clipboard.writeText(value);
		}
		setCopied(true);
	};

	return (
		<Tooltip
			title='Skopiowano'
			open={copied}
			disableHoverListener
		>
			<IconButton
				size='small'
				sx={{ p: 0.25 }}
				aria-label={ariaLabel}
				onClick={handleCopy}
			>
				{copied ? (
					<CheckCircleIcon sx={{ fontSize: 14, color: 'success.main' }} />
				) : (
					<ContentCopyIcon sx={{ fontSize: 14 }} />
				)}
			</IconButton>
		</Tooltip>
	);
};

export default CopyIconButton;
